import api from "../../../services/service_pos";
import Swal from "sweetalert2";
import moment from "moment";
// import apiCenter from "../../../services/service_undefined";
import apiMarim from "../../../services/service_undefined_v2";

export default {
  data () {
    return {
      bill_data: [],
      document: [],
      document_cancel: [],
      hostshift: "",
      search: "",
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      host_list: [],
      host: "",
      branch: {
        id: 0
      },
      dyn_address: "",
      //
      startDate: moment(new Date()),
      endDate: moment(new Date())
    };
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = (this.currentPage - 1) * this.items_perpage;
      return this.bill_data.slice(index, index + this.items_perpage);
    }
  },
  created () {
    // if (sessionStorage.hostshift) {
    //   this.hostshift = JSON.parse(sessionStorage.hostshift)
    //   console.log(this.hostshift)
    // } else {
    //   this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง')
    // }
  },
  methods: {
    changeBranch (data) {
      console.log(data);
      // this.dyn_address = data.dyn_address
      // this.branch = data.branch.id
      console.log(this.dyn_address);
      this.getBillAll();
    },
    getHost () {
      api.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === "success") {
            this.host_list = result.data;
            this.host = this.host_list[0];
            this.tab = 0;
          } else {
            this.alert_msg("warning", "ดึงข้อมูลจุดขายไม่ได้", result.message);
          }
        },
        error => {
          this.alert_msg("error", "ข้อมูลไม่ถูกต้อง", error.data.error);
        }
      );
    },
    setStartTime () {
      this.start_time = this.s_h + this.s_m + this.s_s;
    },
    setEndTime () {
      this.end_time = this.e_h + this.e_m + this.e_s;
    },
    CheckSearch () {
      if (this.search === "") {
        this.onChange(1);
        this.getBillAll();
      }
    },
    itemRender (current, type, originalElement) {
      if (type === "prev") {
        return "Previous";
      } else if (type === "next") {
        return "Next";
      }
      return originalElement;
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber;
    },
    getBillAll () {
      this.$store.commit("Loading");
      var obj = {
        host_code: this.host.host_code,
        keyword: this.search,
        branch_id: this.branch.id
      };
      api.getHoldingBill(
        // this.dyn_address + '/',
        sessionStorage.Url,
        obj,
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        result => {
          if (result.response === "success") {
            // console.log(result.data)
            let dataMap = result.data.map((e) => {
              return {...e, selected: false }
            });
            // console.log(dataMap);
            this.bill_data = dataMap;
          } else {
            this.$notification["warning"]({
              message: "เปิดการขายไม่ได้",
              description: result.message
            });
          }
          this.$store.commit("Loading");
        },
        error => {
          console.log(error);
          this.$store.commit("Loading");
          alert("Error loading", error);
          // this.$notification['error']({
          //   message: 'เรียกรายการไม่ได้',
          //   description: 'กรุณาตรวจสอบ DNS'
          // })
        }
      );
    },
    checkout (obj) {
      this.$store.state.order_data = obj;
      this.$store.state.item_subs = obj.sub;
    },
    cancelBill (data) {
      Swal.fire({
        title: "ยกเลิกบิล",
        text: "ท่านต้องการยกเลิกบิลขายเลขที่ " + data.doc_no + " ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ปิด"
      }).then(res => {
        if (res.value) {
          this.$store.commit("Loading");
          var obj = {
            doc_no: data.doc_no,
            branch_id: this.branch.id
          };
          api.cancelBill(
            // this.dyn_address + '/',
            sessionStorage.Url,
            obj,
            {
              headers: {
                "Access-Token": this.branch.access_token
              }
            },
            result => {
              if (result.response === "success") {
                this.$notification["success"]({
                  message: "ยกเลิกบิล",
                  description: "ยกเลิกบิลเรียบร้อย"
                });
                this.search = "";
              } else {
                this.$notification["warning"]({
                  message: "ยกเลิกบิล",
                  description: "ยกเลิกบิลไม่สมบูรณ์"
                });
              }
              this.$store.commit("Loading");
            },
            error => {
              this.$store.commit("Loading");
              alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            }
          );
        } else {
        }
      });
    },
    printHoldingBill (docNo) {
      var obj = {
        printer_port: this.hostshift.printer_port,
        doc_no: docNo,
        branch_id: this.branch.id
      };
      console.log('printHoldingBill');
      api.printHolding(
        // this.dyn_address + '/',
        sessionStorage.Url,
        obj,
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        result => {
          if (result.response === "success") {
            this.$notification["success"]({
              message: "พิมพ์ใบพักบิลยอดสำเร็จ",
              description: result.message
            });
            this.form_data = JSON.stringify(result.data);
            console.log(JSON.stringify(result.data));
            setTimeout(() => {
              this.$refs.printInvioce.submit();
              this.$store.commit("Loading");
            }, 1000);
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบพักบิลไม่ได้",
              description: result.message
            });
          }
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    printHoldingBillReport (obj) {
      this.$store.commit("Loading");
      console.log('printHoldingBillReport');
      api.billCreditDetail(
        sessionStorage.Url,
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        { doc_no: obj.doc_no, branch_id: this.branch.id },
        result => {
          console.log(result)
          if (result.response === "success") {

            result.data['invoice'] = [obj];
            result.data['bank_account'] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + result.data.def_account_code
            console.log(result.data);
            this.form_data = JSON.stringify(result.data);
            setTimeout(() => {
              this.$refs.printHoldingBill.submit();
              this.$store.commit("Loading");
            }, 1000);
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบแจ้งยอดไม่ได้",
              description: result.message
            });
            this.$store.commit("Loading");
          }
        },
        error => {
          this.$store.commit("Loading");
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    printHoldingPDF (obj) {
      this.$store.commit("Loading");
      console.log('printHoldingPDF');
      api.billCreditDetail(
        // this.dyn_address + '/',
        sessionStorage.Url,
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        { doc_no: obj.doc_no, branch_id: this.branch.id },
        result => {
          console.log(result.data)
          if (result.response === "success") {
            this.form_data = JSON.stringify(result.data);
            setTimeout(() => {
              this.$refs.printHolding.submit();
              this.$store.commit("Loading");
            }, 1000);
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบแจ้งยอดไม่ได้",
              description: result.message
            });
            this.$store.commit("Loading");
          }
        },
        error => {
          this.$store.commit("Loading");
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
        }
      );
    },
    printAllHoldPDF (obj) {
      this.$store.commit("Loading");
      console.log('printAllHoldPDF');
      apiMarim.branchSetting(
        {
          branch_id: this.branch.id.toString()
        },
        this.header,
        results => {
          // console.log(obj);
          if(results.data.status)
          {
            results.data.data['invoice'] = obj;
            results.data.data['bank_account'] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + results.data.data.def_account_code
            console.log(results.data.data);
            console.log(obj);
            this.form_data = JSON.stringify(results.data.data);
            setTimeout(() => {
              this.$refs.printHoldingAll.submit();
              this.$store.commit("Loading");
            }, 1000);
          }
        },
        errors => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
    },
    printSumHoldingBillReport (obj) {
      this.$store.commit("Loading");
      console.log('printSumHoldingBillReport');
      apiMarim.reportInvoice(
        {
          branch_id: this.branch.id.toString(),
          ar_code: obj.ar_code
        },
        this.header,
        results => {
          if(results.data.status)
          {
            let arrObj = [JSON.parse(JSON.stringify(results.data.message))];
            results.data.message['invoice'] = arrObj;
            results.data.message['bank_account'] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + results.data.message.def_account_code
            console.log(results.data.message)
            this.form_data = JSON.stringify(results.data.message);
            setTimeout(() => {
              this.$refs.printHoldingBillSum.submit();
              this.$store.commit("Loading");
            }, 1000);
          }
        },
        errors => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
    },
    printSumHoldingBillReportSelect (obj) {
      this.$store.commit("Loading");
      console.log('printSumHoldingBillReportSelect');
      apiMarim.reportInvoiceSelect(
        {
          branch_id: this.branch.id.toString(),
          doc_no: this.document
        },
        this.header,
        results => {
          if(results.data.status)
          {
            let arrObj = [JSON.parse(JSON.stringify(results.data.message))];
            results.data.message['invoice'] = arrObj;
            results.data.message['bank_account'] = "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " + results.data.message.def_account_code
            console.log(results.data.message)
            this.form_data = JSON.stringify(results.data.message);
            setTimeout(() => {
              this.$refs.printHoldingBillSum.submit();
              this.$store.commit("Loading");
            }, 1000);
          } else {
            this.$store.commit("Loading");
            this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", '');
          }
        },
        errors => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
    },
    AddingCheckDoc (obj) {
      if(this.document.find((e) => e.ar_code === obj.ar_code) || this.document.length === 0) {
        if((this.document.find((e) => e.id !== obj.id) || this.document.length === 0) && !obj.selected) {
          this.document.push({ doc_no: obj.doc_no, ar_code: obj.ar_code, id: obj.id });
        } else {
          this.document = this.document.filter((e) => e.id !== obj.id);
        }
      } else {
        // if (obj.selected) {
        //   this.document_cancel = this.document_cancel.filter((e) => e.id !== obj.id);
        // } else {
        //   this.document_cancel.push({ doc_no: obj.doc_no, ar_code: obj.ar_code, id: obj.id })
        // }
        this.bill_data.forEach(item => {
          if (item.id === obj.id) {
            item.selected = null;
          }
        });
      }
    },
    selectCheckDoc (obj) {
      console.log(obj);
    }
  },
  // watch: {
  //   document_cancel (newValue, oldValue) {
  //     // console.log('Input data changed. New value:', newValue);
  //     // console.log(this.document_cancel);


  //     // this.bill_data.filter((e) => {
  //     //   if(this.document_cancel.find((ex) => ex.id === e.id)) {
  //     //     data.push({ ...e, selected: 0 });
  //     //     console.log('two selected')
  //     //   } else {
  //     //     data.push(e);
  //     //   }
  //     // });
  //     // this.bill_data = data;
  //     // Perform any side effects here based on the new input data
  //   },
  // },

  mounted () {
    this.selectCheckDoc();
    this.getHost();
    this.getBranch();
    this.setStartTime();
    this.setEndTime();
    this.search = "";
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0];
      this.dyn_address = this.$store.state.branch_list[0].dyn_address;
      this.getBillAll();
    }, 1000);
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/bill_credit_list.js